// extracted by mini-css-extract-plugin
export default {"custom-table":"CustomTableApiKey_custom-table__v8eby"};